import { render, staticRenderFns } from "./inventoryReport.vue?vue&type=template&id=8a546860&scoped=true&"
import script from "./inventoryReport.vue?vue&type=script&lang=js&"
export * from "./inventoryReport.vue?vue&type=script&lang=js&"
import style0 from "./inventoryReport.vue?vue&type=style&index=0&id=8a546860&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a546860",
  null
  
)

export default component.exports